import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { FallbackProps } from 'react-error-boundary';
import Button from './button';

export function setWithExpiry(key, value, ttl) {
  const item = {
    value: value,
    expiry: new Date().getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key) {
  const itemString = window.localStorage.getItem(key);
  if (!itemString) return null;

  const item = JSON.parse(itemString);
  const isExpired = new Date().getTime() > item.expiry;

  if (isExpired) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

export function ErrorFallback({ error }: FallbackProps) {
  useEffect(() => {
    const fetchModuleError = 'Failed to fetch dynamically imported module:';
    if (error?.message && error.message.includes(fetchModuleError)) {
      if (!getWithExpiry('imported_module')) {
        setWithExpiry('imported_module', 'true', 10000);
        window.location.reload();
      }
    }
  }, [error]);

  return (
    <Stack height="100vh" alignItems="center" justifyContent="center">
      <h2>Tivemos problemas internos ao acessar</h2>
      <pre>{error?.message}</pre>

      <Button variant="contained" sx={{ mt: 2, width: 200 }}>
        Home
      </Button>
    </Stack>
  );
}
